import type { Message, Role } from '@/types'
import type { StreamMessageModel } from '@/types/message'

class StreamMapper {
  messages: Message[] = []
  private currentMessage: Message | null = null

  convertStreamModelToMessage(streamModel: StreamMessageModel) {
    const {
      character,
      status,
      detail,
    } = streamModel
    if (character.length <= 0) {
      return
    }

    if (status === 'complete') {
      this.saveCurrentMessage()
      this.saveCompleteMessage(streamModel)
      return
    }

    const isSameCharacter = this.currentMessage?.name === character
    if (!isSameCharacter) {
      this.saveCurrentMessage()
    }

    if (streamModel.character === 'Narrator') {
      this.saveNarratorMessage(streamModel)
      return
    }

    if (streamModel.type === 'say') {
      const newMessage: Message = {
        messageId: streamModel.messageId.toString(),
        role: 'char' as Role,
        audioUrl: detail.audio,
        message: detail.content,
        messageTimestampUtc: streamModel.created,
        name: character,
      }
      if (this.currentMessage != null) {
        const hasAction
          = this.currentMessage.action != null
          && this.currentMessage.action.length > 0
        if (hasAction) {
          this.currentMessage.message = newMessage.message
          this.currentMessage.audioUrl = newMessage.audioUrl
          this.messages.push(this.currentMessage)
          this.currentMessage = null
        }
        else {
          this.messages.push(this.currentMessage)
          this.currentMessage = newMessage
        }
      }
      else {
        this.currentMessage = newMessage
      }
    }
    else if (streamModel.type === 'action') {
      const newMessage: Message = {
        messageId: streamModel.messageId.toString(),
        role: 'char' as Role,
        expression: detail.expression,
        action: detail.content,
        message: '',
        messageTimestampUtc: streamModel.created,
        name: character,
      }
      if (isSameCharacter) {
        const hasLastMessageAction
          = this.currentMessage?.action != null
          && this.currentMessage.action.length > 0
        if (this.currentMessage != null) {
          if (hasLastMessageAction) {
            this.messages.push(this.currentMessage)
            this.currentMessage = newMessage
          }
          else {
            this.currentMessage.action = newMessage.action
            this.currentMessage.expression = newMessage.expression
            this.messages.push(this.currentMessage)
            this.currentMessage = null
          }
        }
      }
      else {
        if (this.currentMessage != null) {
          this.messages.push(this.currentMessage)
          this.currentMessage = newMessage
        }
        else {
          this.currentMessage = newMessage
        }
      }
    }
  }

  finalizeMessages() {
    this.saveCurrentMessage()
    return this.messages
  }

  private saveCurrentMessage() {
    if (this.currentMessage != null) {
      this.messages.push(this.currentMessage)
      this.currentMessage = null
    }
  }

  private saveCompleteMessage(streamModel: StreamMessageModel) {
    const completeMessage: Message = {
      messageId: streamModel.messageId.toString(),
      role: 'char' as Role,
      message: '',
      messageTimestampUtc: streamModel.created,
      name: '',
      isComplete: true,
    }
    this.messages.push(completeMessage)
  }

  private saveNarratorMessage(streamModel: StreamMessageModel) {
    const narratorMessage: Message = {
      messageId: streamModel.messageId.toString(),
      role: 'narrator' as Role,
      message: streamModel.detail.content,
      messageTimestampUtc: streamModel.created,
      name: 'Narrator',
      isComplete: false,
    }
    this.messages.push(narratorMessage)
  }
}

export default StreamMapper
